import * as C from './styles';

export const Footer = ()=>{
    return(
        <C.Footer>
            <p>Developed by <strong>Willian Souza</strong></p>
        </C.Footer>
    )
}